import { MONTH_END_DATE } from "../constants/dayOfWeek";
import { extractISOString, getTomorrowsFullDate } from "../utils/dateUtill";
import { fetchStudentPunctualityDateWise } from "../utils/studentUtill";

export const useGenerateCalendar = ({
  calendarCurrentMonth,
  calendarCurrentYear,
  currentDateUTC,
  studentId,
}) => {
  const generateCalendarData = () => {
    const firstDay = new Date(
      calendarCurrentYear,
      calendarCurrentMonth,
      1,
    ).getDay();
    let lastDate = MONTH_END_DATE[calendarCurrentMonth];
    if (calendarCurrentMonth === 1) {
      if (
        (calendarCurrentYear % 4 === 0 && calendarCurrentYear % 100 !== 0) ||
        calendarCurrentYear % 400 === 0
      ) {
        lastDate += 1;
      }
    }
    return { firstDay, lastDate };
  };

  return async () => {
    const { firstDay, lastDate } = generateCalendarData({
      calendarCurrentMonth,
      calendarCurrentYear,
    });
    const queryStartDateTimeUTC = extractISOString(
      new Date(calendarCurrentYear, calendarCurrentMonth, 1),
    );
    let monthsLastFullDate;
    const actualCurrentMonth = currentDateUTC.getUTCMonth();
    const actualCurrentFullYear = currentDateUTC.getUTCFullYear();
    if (
      actualCurrentMonth === calendarCurrentMonth &&
      actualCurrentFullYear === calendarCurrentYear
    ) {
      monthsLastFullDate = currentDateUTC;
    } else {
      monthsLastFullDate = getTomorrowsFullDate(
        new Date(calendarCurrentYear, calendarCurrentMonth, lastDate),
      );
    }
    const queryEndDateTimeUTC = extractISOString(monthsLastFullDate);
    const calendarMatrix = [];
    let date = 1;
    // row < 6 because, if the date starts at 'saturday', then the matrix needs to be of length 6 to handle max 31 days.
    for (let row = 0; row < 6; row += 1) {
      calendarMatrix[row] = [];
      for (let col = 0; col < 7; col += 1) {
        calendarMatrix[row][col] = "";
        if (row === 0 && col >= firstDay) {
          calendarMatrix[row][col] = date;
          date += 1;
        }
        // row > 0 is taken to avoid the conflict with the above if, as it'll fail and col < firstDay and will be caught in else-if.
        else if (row > 0 && date <= lastDate) {
          calendarMatrix[row][col] = date;
          date += 1;
        }
      }
    }
    const updatedDateFlagsResponse = await fetchStudentPunctualityDateWise({
      queryStartDateTimeUTC,
      queryEndDateTimeUTC,
      studentId,
    }).catch((error) =>
      console.log(
        "error while getting date performance in week-report:",
        error,
      ),
    );
    const updatedDateFlags = updatedDateFlagsResponse || {};
    return { calendarMatrix, updatedDateFlags };
  };
};
